// extracted by mini-css-extract-plugin
module.exports = {"container":"crm-c_container__3-KNz"};